<template>
  <app-admin>
    <div class="container content clearfix">
      <loader ref="loader"/>
      <div v-if="player">
        <div class="top-line">
          <h1>Участник {{player.last_name}} {{player.first_name}} {{player.middle_name}}</h1>
          <router-link :to="{ name: 'EditPlayer', params: { id: player.id }}" class="icon">
            <font-awesome-icon icon="edit"/>
          </router-link>
        </div>
        <div class="groups">
          <b>Группы:</b>
          <span v-if="!player.group_set || player.group_set.length == 0">не состоит ни в одной группе.</span>
          <span v-else v-for="group in player.group_set" :key="group.id" @click="removeGroup(group)">{{group.name}}
        <span class="remove-group"
              v-tooltip="{content: 'Исключить участника из этой группы', class: 'tooltip-custom'}">
          <span class="l"></span><span class="r"></span>
        </span>
      </span>
        </div>
        <table class="main-table">
          <thead>
          <tr>
            <th>№</th>
            <th>Название программы</th>
            <th class="w-100">Баллы</th>
            <th class="w-100">Статус</th>
            <th>Дата</th>
            <th class="w-100">Отчет</th>
            <th class="text-center">Подробнее</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(test, index) in tests" :key="test.id">
            <td>{{index + 1}}</td>
            <td>{{test.name}}</td>
            <td class="no-padding" colspan="4">
              <table class="results-table">
                <tr v-for="result in test.results" :key="result.id">
                  <td class="no-padding w-100 text-center blue">
                    <span v-if="testScore">{{scorePoints(result.payload.score, testScore)}}</span>
                    <span v-else>0</span>
                  </td>
                  <td class="w-100 text-center">
                    <span v-if="result.payload">{{result.payload.success?'Пройден':'Не пройден'}}</span>
                    <span v-else>—</span>
                  </td>
                  <td class="text-center">
                    <span v-if="result.date_completed">{{result.date_completed | date('HH:mm, DD.MM.YY')}}</span>
                    <span v-else>—</span>
                  </td>
                  <td class="w-100 text-center report">
                    <router-link :to="{name: 'Result', params: {playerId: player.id, resultId: result.id}}"
                                 v-if="result.date_completed">
                      <div class="btn">Отчет</div>
                    </router-link>
                  </td>
                </tr>
              </table>
            </td>
            <td class="w-100 text-center">
              <div class="btn-more" @click="loadMoreResults(test.id)" v-if="test.attempt > 1">
                <span v-if="test.results.length == 1">+ {{test.attempt - 1}}</span>
                <span v-else><font-awesome-icon icon="angle-up"/></span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="buttons-group-right">
          <router-link :to="{name: 'Players'}">
            <div class="btn btn-light">
              <font-awesome-icon icon="angle-left"/>
              Вернуться к списку участников
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </app-admin>
</template>

<script>
  import PlayersService from '@/services/PlayersService'
  import TestsService from '@/services/TestsService'
  import Vue from 'vue'

  export default {
    name: 'Player',
    data () {
      return {
        player: {
          first_name: '',
          middle_name: '',
          last_name: '',
          groups: []
        },
        results: [],
        tests: [],
        currTest: {},
        a: 1,
        testScore: ''
      }
    },
    methods: {
      removeGroup (group) {
        PlayersService.removePlayerFromGroup(group.id, this.player.id).then(
          (response) => {
            let groupIndex = this.player.group_set.findIndex(x => x.id === group.id)
            this.player.group_set.splice(groupIndex, 1)
          }
        )
      },
      scorePoints (score, test) {
        let result = Math.floor(score * 100 / test)
        return result
      },
      loadMoreResults (testId) {
        let testIndex = this.tests.findIndex((x) => parseInt(x.id) === testId)
        let test = this.tests[testIndex]
        if (test.results.length > 1) {
          test.results.splice(1)
          Vue.set(this.tests, testIndex, test)
        } else {
          TestsService.getTestResultsByPlayerIdAndGroupId(this.slug, this.playerId, testId).then(
            (response) => {
              test.results = response
              Vue.set(this.tests, testIndex, test)
            }
          )
        }
      }
    },
    computed: {
      slug () {
        return this.$store.getters.slug
      },
      playerId () {
        return this.$route.params.id
      },
      groupId () {
        return this.$store.getters.groupId
      }
    },
    mounted () {
      this.$refs.loader.show()
      PlayersService.getPlayer(this.playerId).then(
        (response) => {
          this.player = response
          TestsService.getTestResultsByPlayerId(this.slug, this.player.id).then(
            (response) => {
              let testArr = this.tests
              this.results = response
              this.results.forEach((res) => {
                let test = res.test
                test.results = [res]
                test.attempt = res.attempt || 0
                testArr.push(test)
                TestsService.getTest(this.slug, test.id).then(
                  (response) => {
                    this.testScore = response.score
                  }
                )
              })
              console.log(this.tests)
              this.$refs.loader.hide()
            }
          )
        },
        (error) => {
          console.log(error)
        }
      )
    }
  }
</script>

<style scoped lang="scss">
  .top-line {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .groups {
    margin-bottom: 30px;
    span, b {
      display: inline-block;
      vertical-align: middle;
    }
    .remove-group {
      background-color: $very-light-blue;
      width: 27px;
      height: 24px;
      position: relative;
      margin-left: 3px;
      margin-right: 20px;
      border-radius: 5px;
      cursor: pointer;
      &:hover {
        .l, .r {
          background-color: $blue;
        }
      }
    }
    .l, .r {
      position: absolute;
      top: 11px;
      height: 3px;
      width: 15px;
      background-color: $light-blue;
    }
    .l {
      left: 6px;
      transform: rotate(45deg);
    }
    .r {
      right: 6px;
      transform: rotate(-45deg);

    }
  }

  .main-table {
    width: 100%;
    text-align: center;
    font-weight: 300;
    margin-bottom: 120px;
    border-collapse: collapse;
    th {
      font-weight: 400;
      color: #808080;
      font-size: 13px;
    }
    th, td {
      padding: 10px 5px;
      border-bottom: 1px solid $light-blue;
      &:nth-child(1), &:nth-child(2) {
        text-align: left;
      }
    }
    .btn {
      padding: 7px 20px;
    }
  }

  .icon {
    padding: 10px;
    margin-left: 20px;
    &:hover path {
      fill: $blue;
    }
    path {
      fill: $light-blue;

    }
  }

  .no-padding {
    padding: 0 !important;
  }

  .results-table {
    table-layout: fixed;
    text-align: center;
    border-collapse: collapse;
    width: 450px;
    td {
      border: none;
      padding: 5px;
    }
  }

  .w-100 {
    width: 100px;
  }

  .report {
    padding: 4px !important;
  }

  .blue {
    color: $blue;
    font-weight: 400;
  }

  .btn-more {
    width: 30px;
    svg {
      margin-left: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/players/Player.vue